<template>
  <div class="container">
    <breadcrumb v-if="!isMobile" crumb="contragent-list" />
    <section class="contragents_section">
      <el-row :gutter="24">
        <el-col :span="12">
          <search-input
            placeholder="Поиск по Названию организации (ИП), ИНН"
            @clear="clearFilter"
            @search="listContr"
            @input="onInput"
          />
        </el-col>
        <el-col v-if="accessFilterMenu" :span="12">
          <el-row type="flex" justify="end" class="add_contr">
            <p @click="addContrAgent">Добавить контрагента</p>
            <div class="append-box">
              <img
                style="margin: 0 10px 0 20px"
                src="@/assets/img/phone.svg"
                alt=""
              />
              <span style="display: grid; align-items: center">
                {{ getTotalCount }}
              </span>
            </div>
          </el-row>
          <el-collapse class="contragent-collapse">
            <el-collapse-item>
              <div slot="title" class="btn-title">
                <el-button type="text">Дополнительно</el-button>
              </div>
              <el-row type="flex" justify="end" class="add_contr">
                <p @click="goToAddGroup">Группы контрагентов</p>
                <div class="append-box">
                  <img
                    style="margin: 0 10px 0 20px"
                    src="@/assets/img/small-user.svg"
                    alt=""
                  />
                  <span style="display: grid; align-items: center">49</span>
                </div>
              </el-row>
              <approve-filters
                v-if="accessFilterMenu"
                :loading="loadingStats"
                :statistics="contragentsStats"
                :status="status"
                @setStatus="setStatus"
              />
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
      <section class="middle-section">
        <template v-if="!accessFilterMenu"> <br /><br /> </template>
        <el-table
          v-if="loading || !filteredContragents.length"
          v-loading="loading"
          :data="filteredContragents"
          style="width: 100%; height: 40vh; margin-top: 40px"
        />
        <el-row
          v-if="filteredContragents.length && !loading"
          type="flex"
          :gutter="24"
          style="text-align: center"
        >
          <el-col :span="1">
            <div class="check-list-person auto-list_col_centered">
              <el-checkbox
                v-if="filteredContragents.length && !loading"
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
              />
            </div>
          </el-col>
          <el-col :span="2">Дата</el-col>
          <el-col :span="7">Название</el-col>
          <el-col :span="3">ИНН и телефон</el-col>
          <el-col :span="4">Договор ПТ</el-col>
          <el-col :span="4">Договор ПТЭ</el-col>
          <el-col :span="3" />
        </el-row>
        <el-checkbox-group
          v-if="filteredContragents.length && !loading"
          v-model="checkedContragents"
          @change="handleCheckedChange"
        >
          <transition-group name="slide-fade" tag="div">
            <div
              v-for="contragent in filteredContragents"
              :key="contragent.id"
              class="check-list"
              style="cursor: default"
            >
              <el-row :gutter="24" type="flex" align="middle">
                <el-col class="auto-list_col" :span="1">
                  <div class="check-list-time auto-list_col_centered">
                    <el-checkbox :label="contragent" :value="contragent" />
                  </div>
                </el-col>
                <el-col class="auto-list_col" :span="2">
                  <div
                    v-loading="loadingUpdate && updatedInn === contragent.inn"
                    class="check-list-person auto-list_col_centered"
                  >
                    <div>
                      <p class="date">
                        {{ dateToFormat(contragent.created_at) | wordDate }}
                      </p>
                      <p class="date">
                        {{ dateToFormat(contragent.created_at) | sliceDate }}
                      </p>
                    </div>
                  </div>
                </el-col>
                <el-col class="auto-list_col" :span="7">
                  <div
                    v-loading="loadingUpdate && updatedInn === contragent.inn"
                    class="check-list-person auto-list_col_centered"
                  >
                    <div>
                      <p>{{ contragent.org_name }}</p>
                      <el-rate
                        v-model="rate_user"
                        disabled
                        :colors="rate_color"
                      />
                      <taxation-status :status="contragent.nds_status" />
                    </div>
                  </div>
                </el-col>
                <el-col class="auto-list_col" :span="3">
                  <div
                    v-loading="loadingUpdate && updatedInn === contragent.inn"
                    class="check-list-phone grey auto-list_col_centered"
                  >
                    <div class="check-list-autos">
                      <p>ИНН {{ contragent.inn }}</p>
                      <p>{{ contragent.phone }}</p>
                    </div>
                  </div>
                </el-col>
                <el-col class="auto-list_col" :span="4">
                  <div
                    v-loading="loadingUpdate && updatedInn === contragent.inn"
                    class="check-list-autos auto-list_col_centered"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :disabled="
                        contractCheck(contragent, PT).numFull.length <= 16
                      "
                      :content="contractCheck(contragent, PT).numFull"
                      placement="top"
                    >
                      <span
                        :class="
                          contractCheck(contragent, PT).numFull.length > 1 &&
                          'unselectable'
                        "
                        class="contragents_section__doc"
                        @dblclick="
                          doubleClickToCopyText(
                            contractCheck(contragent, PT).numFull,
                          )
                        "
                      >
                        {{ contractCheck(contragent, PT).numShort }}
                      </span>
                    </el-tooltip>

                    <div class="contragents_section__tag">
                      <el-tag
                        :type="contractCheck(contragent, PT).type"
                        effect="dark"
                        size="mini"
                      >
                        {{ contractCheck(contragent, PT).title }}
                      </el-tag>
                    </div>

                    <p class="contragents_section__doc">
                      {{ contractCheck(contragent, PT).doc }}
                    </p>
                  </div>
                </el-col>
                <el-col class="auto-list_col" :span="4">
                  <div
                    v-loading="loadingUpdate && updatedInn === contragent.inn"
                    class="check-list-autos auto-list_col_centered"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :disabled="
                        contractCheck(contragent, PTE).numFull.length <= 16
                      "
                      :content="contractCheck(contragent, PTE).numFull"
                      placement="top"
                    >
                      <span
                        :class="
                          contractCheck(contragent, PTE).numFull.length > 1 &&
                          'unselectable'
                        "
                        class="contragents_section__doc"
                        @dblclick="
                          doubleClickToCopyText(
                            contractCheck(contragent, PTE).numFull,
                          )
                        "
                      >
                        {{ contractCheck(contragent, PTE).numShort }}
                      </span>
                    </el-tooltip>

                    <div class="contragents_section__tag">
                      <el-tag
                        :type="contractCheck(contragent, PTE).type"
                        effect="dark"
                        size="mini"
                      >
                        {{ contractCheck(contragent, PTE).title }}
                      </el-tag>
                    </div>

                    <p class="contragents_section__doc">
                      {{ contractCheck(contragent, PTE).doc }}
                    </p>
                  </div>
                </el-col>
                <el-col class="auto-list_col double_button" :span="3">
                  <div class="check-list-delete auto-list_col_centered">
                    <div class="icon-list">
                      <template v-if="canEdit(contragent.user_org_inn)">
                        <el-button
                          type="primary"
                          icon="el-icon-edit"
                          circle
                          @click="showEditModal(contragent)"
                        />
                        <el-button
                          type="danger"
                          icon="el-icon-delete"
                          circle
                          @click="deleteContragents(contragent.id)"
                        />
                      </template>
                      <el-button
                        v-else
                        type="primary"
                        icon="el-icon-view"
                        circle
                        @click="viewContragent(contragent)"
                      />
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </transition-group>
        </el-checkbox-group>
      </section>
    </section>
    <section
      v-if="!isMobile && filteredContragents.length && !loading"
      class="bottom-section"
    >
      <div class="pagination">
        <pagination-custom :data="pagination" @changed="changePage" />
      </div>
      <div class="bottom-section-action">
        <p>Выбрано {{ checkedContragents.length }} элементов</p>
        <el-col class="auto-list_col" :span="4">
          <el-button
            style="background: #e9e9e9; color: #778ca2; border-radius: 4px"
            class="text-block"
            @click="sendApprove(2)"
          >
            ОТКАЗАТЬ
          </el-button>
        </el-col>
        <el-col class="auto-list_col" :span="4">
          <el-button
            style="background: #e9e9e9; color: #778ca2; border-radius: 4px"
            class="text-block"
            @click="sendApprove(1)"
          >
            УТВЕРДИТЬ
          </el-button>
        </el-col>
        <el-col class="auto-list_col" :span="4">
          <el-button
            type="info"
            :disabled="disabled"
            plain
            @click="dellArrContragents"
          >
            <p>Удалить</p>
          </el-button>
        </el-col>
      </div>
    </section>
    <el-dialog
      class="add-contragent_dialog"
      title="Добавление контрагента"
      :visible.sync="dialog_add_contr"
      width="600px"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <new-contragents @edited="toEdit" @saved="saveContragent" />
    </el-dialog>
    <el-dialog
      title="Редактирование контрагента"
      :visible.sync="dialog_edit_contr"
      width="60%"
      @close="closeDialog(true)"
    >
      <contragent-edit
        :contragent="editedContragent"
        @updatedContract="updateContract"
      />
    </el-dialog>

    <el-dialog
      title="Карточка предприятия"
      :visible.sync="dialog_view_contr"
      width="50%"
      center
      :close-on-click-modal="false"
      @close="closeDialog()"
    >
      <company-card :contragent="editedContragent" />
    </el-dialog>
  </div>
</template>

<script>
import * as _ from 'lodash'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { documents_workflow_for_table } from '@/helpers/typeContract'
import { doubleClickToCopyText } from '@/helpers/doubleClickToCopyText'
import { getFilterStatus, kitcutText } from '@/helpers/functions'
import { mapActions, mapGetters } from 'vuex'
import ApproveFilters from '@/components/Shared/ApproveFilters'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import CompanyCard from '@/views/Company/CompanyCard'
import ContragentEdit from '@/components/Contragents/ContragentEdit'
import NewContragents from '@/components/Contragents/NewContragents'
import PaginationCustom from '@/components/Tables/PaginationCustom'
import SearchInput from '@/components/Shared/SearchInput'
import TaxationStatus from '@/components/Shared/TaxationStatus'

const Contragents = RepositoryFactory.get('contragents')
const Approvements = RepositoryFactory.get('approvements')

export default {
  name: 'ContragentsList',
  components: {
    TaxationStatus,
    ContragentEdit,
    ApproveFilters,
    NewContragents,
    PaginationCustom,
    CompanyCard,
    Breadcrumb,
    SearchInput,
  },
  data() {
    return {
      updatedInn: null,
      PT: 2315190510,
      PTE: 2315996340,
      checkAll: false,
      isIndeterminate: false,
      rate_user: 3,
      curPage: 1,
      dialog_add_contr: false,
      dialog_edit_contr: false,
      dialog_view_contr: false,
      checkedContragents: [],
      pagination: {},
      rate_color: [],
      status: '',
      search_input: '',
      editedContragent: {},
      editedContragentId: null,
    }
  },
  computed: {
    ...mapGetters({
      getContragents: 'getContragents',
      getTotalCount: 'getTotalCount',
      getMeta: 'getMeta',
      loading: 'getContragentLoading',
      loadingUpdate: 'getContragentLoadingUpdate',
    }),

    contragentsStats() {
      return this.$store.state.contragent.contragentsStats
    },
    loadingStats() {
      return this.$store.state.contragent.loadingStatistics
    },
    accessFilterMenu() {
      return this.$canAction('filter_menu', this.userInfo)
    },
    filteredContragents() {
      return this.getContragents
    },
    disabled() {
      return !(this.checkedContragents.length >= 1)
    },
    canEdit() {
      return orgInn =>
        this.isAdminOrCeoRole || Number(this.cur_org_inn) === Number(orgInn)
    },
  },
  watch: {
    status: {
      handler: 'listContr',
      immediate: false,
    },
    filteredContragents: {
      deep: true,
      handler() {
        if (this.editedContragentId) {
          this.setEditedContragent()
        }
      },
    },
  },
  mounted() {
    this.checked = false
    this.rate_user = 3
    this.rate_color = ['#3498DB', '#3498DB', '#3498DB']
    this.loadPage()
  },
  updated() {
    this.pagination = this.getMeta
  },
  methods: {
    ...mapActions([
      'fetchContragentByInn',
      'fetchContragentsStatistics',
      'fetchContragents',
    ]),
    doubleClickToCopyText,

    updateContract() {
      this.updatedInn = this.editedContragent?.inn
    },
    async loadPage() {
      this.checkStatusFilter()
      this.listContr(this.status)
      await this.$store.dispatch('fetchContragentsStatistics')
    },
    contractCheck(documents, organization) {
      const contract = documents?.contracts?.[organization]

      const result = {
        type: 'danger',
        title: 'Договор отсутствует',
        doc: ' ',
        numShort: ' ',
        numFull: ' ',
      }

      // проверка статусов договора

      if (
        contract &&
        contract['current_document']?.is_signed &&
        contract['current_document']?.files.length >= 1
      ) {
        result.type = 'success'
        result.title = 'Договор подписан'
      }
      if (
        contract &&
        contract?.current_document?.is_signed === 0 &&
        contract['current_document']?.files.length >= 1
      ) {
        result.type = 'warning'
        result.title = 'Договор загружен'
      }

      // проверка типа договора
      if (
        contract &&
        contract.documents_workflow &&
        contract['current_document']?.files.length >= 1
      ) {
        result.doc =
          documents_workflow_for_table.find(
            item => item.value === contract.documents_workflow,
          )?.label || ' '
      }
      // извлечение номера договора
      if (
        contract &&
        contract['current_document']?.is_current &&
        contract['current_document']?.number
      ) {
        result.numShort = kitcutText(
          `№  ${contract['current_document']?.number}`,
          16,
        )
        result.numFull = `№  ${contract['current_document']?.number}`
      }

      return result
    },
    onInput(cur) {
      this.search_input = cur
    },
    setStatus(status) {
      this.status = status || ''
    },
    clearFilter() {
      this.search_input = ''
      this.changePage()
    },
    changePage(page = 1) {
      this.curPage = page
      this.listContr()
    },
    listContr(value) {
      const master_approve_status = getFilterStatus(value)
      const search = String(this.search_input).trim()

      this.fetchContragents({
        page: this.curPage,
        master_approve_status,
        search,
      })
    },
    toEdit(contragent, flag = false) {
      if (flag) {
        this.listContr()
        this.$store.dispatch('fetchContragentsStatistics')
      }
      this.editContragent(contragent, flag)
    },
    checkStatusFilter() {
      const query = this.$route.query

      if (query.status && query.status === '0') {
        this.status = query.status
      }
    },
    filterByStatus(status) {
      this.status = status
    },
    addContrAgent() {
      this.dialog_add_contr = true
      this.dialog_view_contr = false
    },
    setEditedContragent() {
      this.editedContragent = {}
      this.$nextTick(() => {
        this.editedContragent = _.cloneDeep(
          this.filteredContragents.find(
            item => item.id === this.editedContragentId,
          ),
        )
      })
    },
    showEditModal(item) {
      this.dialog_edit_contr = true
      this.editedContragentId = item.id
      this.setEditedContragent()
    },
    saveContragent() {
      this.dialog_add_contr = false
    },
    // если при создании нового контрагента проваливаться сразу в добавление документов
    editContragent(contragent, flag = false) {
      this.dialog_add_contr = false
      this.dialog_view_contr = false
      this.editedContragentId = contragent.id
      this.setEditedContragent()
      this.dialog_edit_contr = true

      if (flag) {
        this.$alert('Контрагент создан проверьте данные')
      }
    },
    viewContragent(contragent) {
      this.dialog_add_contr = false
      this.dialog_edit_contr = false
      this.editedContragent = contragent
      this.dialog_view_contr = true
    },
    async closeDialog(flag) {
      if (flag) {
        this.editedContragentId = null
        this.updateContract()
        await this.fetchContragentByInn(this.editedContragent?.inn)
      }
    },
    dellArrContragents() {
      this.$confirm('Вы действительно хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      })
        .then(() => {
          for (let index = 0; index < this.checkedContragents.length; index++) {
            const element = this.checkedContragents[index]

            Contragents.deleteContragents(element.id).then(() => {
              this.deleteContragentsFromArr(element.id)
            })
          }
        })
        .catch(() => {})
    },
    deleteContragents(id) {
      this.$confirm('Вы действительно хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      })
        .then(() => {
          Contragents.deleteContragents(id)
            .then(() => {
              this.deleteContragentsFromArr(id)
            })
            .catch(err => this.$message.error(err.response.data[0].message))
        })
        .catch(() => {})
    },
    deleteContragentsFromArr(id) {
      this.getContragents.splice(
        this.getContragents.findIndex(i => i.id === id),
        1,
      )
    },
    handleCheckAllChange(val) {
      this.checkedContragents = val ? this.getContragents : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      let checkedCount = value.length

      this.checkAll = checkedCount === this.getContragents.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.getContragents.length
    },
    goToAddGroup() {
      this.$router.push({ path: '/contragents/group' })
    },
    sendApprove(newStatus) {
      this.checkedContragents.map(contragent => {
        Approvements.postApprovements({
          link_by_rel: 'contragents',
          link_by_id: contragent.id,
          status: newStatus,
          user_org_inn: Number(this.cur_org_inn),
        }).then(() => this.listContr())
      })
    },
  },
}
</script>

<style lang="sass">
.add-contragent_dialog
  .el-dialog__header
    padding: 30px 20px 20px
  .el-dialog__body
    color: #000
    padding: 0 20px 20px
.notificator_text
  font-family: "Rubik", sans-serif
.contragents_section
  .contragent-collapse
    border: none
    margin-bottom: 20px
    .el-collapse-item__header, .el-collapse-item__wrap
      background-color: #F9F9F9
      border: none
    .btn-title
      width: 100%
      text-align: right
      button
        padding: 5px 10px
        font-size: 16px
        color: #3498DB
        &:hover
          color: #66b1ff
    .el-collapse-item__arrow
      font-size: 20px
      color: #3498DB
  .add_contr
    p
      font-size: 18px
      line-height: 21px
      color: #3498DB
      &:hover
        text-decoration: underline
        cursor: pointer
    .append-box
      width: 100px
      display: flex
    .el-icon-star-off
      font-size: 24px
      margin: 0 25px 0 15px
  .double_button
    & .icon-list
      display: flex
      justify-content: center

  .select-all-d
    margin: 0
    &:hover
      cursor: pointer
      text-decoration: underline
      .el-checkbox__label
        color: #3498DB
        text-decoration: underline

  .auto-list_col
    .check-list-person
      p.date
        font-size: 14px
        line-height: 21px
    .auto-list_col_centered
      align-content: center

  &__doc
    margin: 0
    min-height: 14px
    line-height: 1
    * + &
      margin-top: 6px
  &__tag
    * + &
      margin-top: 6px

.el-dialog, .el-pager li
  border-radius: 6px !important

.el-dialog__footer
  border-top: 0.5px solid #CBCFD5
  display: flex
  justify-content: flex-end

.user_input_info
  -webkit-appearance: none
  background-color: #FFF
  background-image: none
  border-radius: 4px
  border: 1px solid #DCDFE6
  -webkit-box-sizing: border-box
  box-sizing: border-box
  color: #606266
  display: inline-block
  font-size: inherit
  height: 40px
  line-height: 40px
  outline: 0
  padding: 0 15px
  width: 100%

.user_input_info_texta
  height: 70px

.add_group_form
  display: flex
  .add_group_form_contragents, .add_group_form_groups
    padding: 10px
    border: 1px solid rgba(113, 201, 222, 0.8)
    height: 336px
    width: 50%
  .contr-list
    margin: 0
    padding: 0
    li
      list-style-type: none
      height: 40px
      border: .5px solid #DCDFE6
      display: flex
      align-items: center
      padding-left: 20px
      background: #fff
      &:first-child
        border-bottom: none
        border-top-right-radius: 4px
        border-top-left-radius: 4px
      &:last-child
        border-top: none
        border-bottom-right-radius: 4px
        border-bottom-left-radius: 4px
      span
        margin-right: 1px

  .add_group_form_list
    height: 245px
    overflow: hidden
    -ms-overflow-style: none
    overflow: -moz-scrollbars-none
    &::-webkit-scrollbar
      width: 0

    .inside_scroll
      padding: 0 18px 0 0
      width: 100%
      height: 100%
      overflow: auto
.unselectable
  -webkit-touch-callout: none
  -webkit-user-select: none
  -khtml-user-select: none
  -moz-user-select: none
  -ms-user-select: none
  user-select: none
  cursor: pointer
</style>
